import { useState } from 'react';
import type { ReactElement } from 'react';

import {
  BpkAccordion,
  BpkAccordionItem,
} from '@skyscanner-internal/backpack-web/bpk-component-accordion';
import { BpkGrid, BpkSpacing } from '@skyscanner-internal/backpack-web/bpk-component-layout';
import { TEXT_STYLES } from '@skyscanner-internal/backpack-web/bpk-component-text';
import { translate } from '@web-platform/shared-universal-translations';

import InternationalSiteCard from './InternationalSiteCard/InternationalSiteCard';

import type { InternationalSite } from '@web-platform/shared-universal-types/src/apis/context/seoComponents';

type Props = {
  internationalSites: InternationalSite[];
};

const InternationalSites = ({ internationalSites }: Props): ReactElement => {
  const [expanded, setExpanded] = useState(false);

  return (
    <BpkAccordion>
      <BpkAccordionItem
        id="internationalSites-group"
        expanded={expanded}
        onClick={() => {
          setExpanded(!expanded);
        }}
        tagName="h3"
        textStyle={TEXT_STYLES.heading3}
        title={translate('seo_international_sites_heading')}
      >
        <BpkGrid
          marginTop={BpkSpacing.LG}
          templateColumns={{
            base: '1fr',
            'small-tablet': 'auto auto',
            desktop: 'auto auto auto',
          }}
          aria-hidden={!expanded}
        >
          {internationalSites.map((site) => (
            <InternationalSiteCard siteData={site} key={site.text} isAccordionExpanded={expanded} />
          ))}
        </BpkGrid>
      </BpkAccordionItem>
    </BpkAccordion>
  );
};

export default InternationalSites;
